import React from "react";
import Header from "src/components/common/Header";
import Sidebar from "src/components/common/Sidebar";
import Footer from "src/components/common/Footer";
import { RODEO_PAGE_NAME } from "src/_config/site_statics";
import PaymentCancel from "src/components/settings/subscriptions/PaymentCancel";

const PaymentCancelContainer: React.FC = () => {
  return (
    <>
      <Header variant="topbar" />
      <Sidebar page={RODEO_PAGE_NAME.SETTINGS_SUBSCRIPTIONS} />
      <PaymentCancel />
      <Footer variant="dashboard" />
    </>
  );
};

export default PaymentCancelContainer;
